const e = {
  root: {
    base: "flex items-center gap-2 px-3 py-2 border border-border rounded-lg dark:bg-[#DCE6FF] bg-[#DCE6FF]/10 text-dark hover:border-primary transition-colors group",
    icon: "h-5 w-5 group-hover:text-primary transition-colors",
    dates: "text-sm font-medium",
    daysCount: "text-[10px] uppercase tracking-wider font-bold text-muted-foreground bg-mutedDark px-2 py-0.5 rounded-md"
  },
  popover: {
    root: {
      base: "w-auto p-0 pointer-events-auto glass shadow-lg border border-border rounded-lg",
      content: "p-4 min-w-[600px]"
    },
    header: {
      base: "flex items-center justify-between mb-4",
      selector: {
        base: "flex items-center gap-2",
        select: "bg-transparent text-foreground font-semibold text-sm border-none p-1 cursor-pointer focus:outline-hidden focus:ring-0 z-50 hover:bg-white/10 rounded transition-colors"
      }
    },
    view: {
      month: {
        base: "flex-1",
        label: "text-center font-semibold text-white mb-4",
        weekdays: {
          base: "grid grid-cols-7 gap-1 mb-2",
          item: "text-center text-xs text-muted-foreground font-medium py-1"
        },
        dates: {
          base: "h-9 w-full rounded-lg text-sm transition-all relative font-semibold hover:glass-20",
          disabled: "text-muted-foreground/40 cursor-not-allowed hover:bg-transparent",
          start: "bg-dark text-white dark:bg-white dark:text-dark hover:bg-dark/90 dark:hover:bg-white/90 rounded-r-none",
          end: "bg-dark text-white dark:bg-white dark:text-dark hover:bg-dark/90 dark:hover:bg-white/90 rounded-l-none",
          inRange: "glass-40 rounded-none text-white",
          today: "ring-2 ring-primary"
        }
      }
    },
    quickFilters: {
      base: "flex items-center gap-2 mt-6 pt-4 border-t border-border flex-wrap",
      title: "text-xs text-foreground mr-2",
      separator: "text-foreground text-xs",
      button: "cursor-pointer",
      activeButton: "bg-dark text-white dark:bg-white dark:text-dark"
    },
    footer: {
      base: "flex items-center justify-between mt-4 pt-4 border-t border-border"
    }
  }
};
export {
  e as periodDatePickerTheme
};
